import bem from 'utils/bem';

export const block = bem('modal-v2');
